import _ from 'lodash';
import $ from 'jquery';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';

function getOrientation() {
  if (parseInt($(window).width(), 10) >= parseInt($(window).height(), 10)) {
    return 'Landscape';
  }
  return 'Portrait';
}

function getViewport() {
  return $(window).width() + 'x' + $(window).height();
}

function getRenderedExperience() {
  const mediaString = MediaQuery.current;

  if (mediaString.match(/large/g)) {
    return 'large';
  } else if (mediaString.match(/medium/g)) {
    return 'medium';
  } else if (mediaString.match(/small/g)) {
    return 'small';
  }
  return '';
}

function getBrandSymbol(brand) {
  switch (_.toLower(brand)) {
    case 'gmc-fleet':
    case 'chevrolet-fleet':
    case 'cadillac-fleet':
    case 'buick-fleet':
    case 'gmc':
      return 'gm';
    case 'chevrolet':
      return 'ch';
    case 'cadillac':
      return 'ca';
    case 'buick':
      return 'bu';
    default:
      return '';
  }
}

function getSiteName(country) {
  const siteName =
    window.appResources.worldPlatformMode === 'QUANTUM' ? 'quantum_' : 'gmwp_';
  return siteName + country;
}

export const initialize = postalCode => {
  const {
    language,
    year,
    brand,
    carline,
    continent,
    featureGroup
  } = window.appResources;

  const region = _.toLower(continent);
  const country = _.toLower(window.appResources.country);

  window.digitalData = {
    pageInfo: {
      pageName:
        getBrandSymbol(brand) +
        ':' +
        region +
        ':' +
        country +
        ':' +
        language +
        ':t1:vehicles',
      siteSectionsLevel1: year,
      siteSectionsLevel2: featureGroup,
      siteSectionsLevel3: carline,
      siteSectionsLevel4: 'build-your-own',
      siteName: getSiteName(country),
      url: window.location.href,
      languageSelected: language,
      brand,
      country: country,
      region: 'gm' + region,
      renderedExperience: getRenderedExperience(),
      viewport: getViewport(),
      orientation: getOrientation()
    },
    vehicleInfo: {
      modelName: carline,
      modelYear: year,
      vehicleType: featureGroup
    },
    visitorProfile: {
      zipCode: postalCode
    },
    toolsInfo: {},
    forms: {}
  };

  if (window._satellite) {
    window._satellite.track('start_byo');
  }

  window.addEventListener('resize', () => {
    window.digitalData.pageInfo.viewport = getViewport();
    window.digitalData.pageInfo.orientation = getOrientation();
    window.digitalData.pageInfo.renderedExperience = getRenderedExperience();
  });
};

export const trackStateChanged = (fromPath, toPath) => {
  let pageName = null;
  let siteSection = '';

  window.digitalData.pageInfo.url = window.location.href;

  switch (toPath) {
    case '/summary/payment':
      pageName = 'estimate-load';
      siteSection = 'payment-estimate';
      break;
    case '/summary/share':
      pageName = 'savesend-load';
      siteSection = 'save-send';
      break;
    case '/trim/compare/capabilities/table':
    case '/config/compare/capabilities/table':
      pageName = 'capabilities-load';
      siteSection = 'compare-capabilities';
      break;
    case '/trim/compare/trims/table':
    case '/config/compare/trims/table':
      pageName = 'featcomp-load';
      siteSection = 'compare-trims';
      break;
    case '/features/trims/table':
      pageName = 'compare-trim-load';
      siteSection = 'feature-trims';
      break;
    case '/features/capabilities/table':
      pageName = 'feature-trim-load';
      siteSection = 'feature-capabilities';
      break;
    case '/config':
    case '/trim':
    case '/color':
    case '/packages':
    case '/interior':
    case '/exterior':
    case '/accessories':
    case '/summary':
      (siteSection = _.trimStart(toPath, '/')),
        (pageName = siteSection + '-load');
      break;
  }

  if (!window.digitalData.pageInfo.renderedExperience) {
    window.digitalData.pageInfo.renderedExperience = getRenderedExperience();
  }

  if (window._satellite && fromPath !== toPath && pageName != null) {
    window.digitalData.pageInfo.siteSectionsLevel5 =
      window.digitalData.pageInfo.siteSectionsLevel1 +
      ':' +
      window.digitalData.pageInfo.siteSectionsLevel2 +
      ':' +
      window.digitalData.pageInfo.siteSectionsLevel3 +
      ':' +
      window.digitalData.pageInfo.siteSectionsLevel4 +
      ':' +
      siteSection;

    window._satellite.track(pageName);
  }
};

function getZeroLight(params, config) {
  const { peg, selections } = config;
  const { modelyear } = params;
  const mmcPeg = peg.replace(/__/, '_');
  const { exteriorColor, interiorColor, rpos } = selections;

  const rposString = rpos
    .filter(rpo => rpo !== exteriorColor && rpo !== interiorColor)
    .join('|');

  return `${modelyear}|${mmcPeg}|${exteriorColor}|${interiorColor}|${rposString}`;
}

export const setConfig = (params, fullConfig) => {
  const style = fullConfig.style;
  const driveTypeId = fullConfig.selections.driveType;

  let vehicleInfo = window.digitalData.vehicleInfo;
  let toolsInfo = window.digitalData.toolsInfo;

  window.digitalData.visitorProfile.zipCode = params.postalCode;

  vehicleInfo.bodyStyle = params.bodystyle;
  vehicleInfo.trimLevel = style.trimName;

  toolsInfo.engine = style.styleConfig.engine;
  toolsInfo.transmission = style.styleConfig.transmission;
  toolsInfo.wheels = driveTypeId;
  toolsInfo.options = fullConfig.config.VEHICLE.SELECTED_RPO_LIST.join();
  toolsInfo.accessorires = fullConfig.config.VEHICLE.SELECTED_ACCESSORY_LIST.join();
  toolsInfo.configIntColorUpholstery = fullConfig.selections.interiorColor;
  toolsInfo.configExtColor = fullConfig.selections.exteriorColor;
  toolsInfo.configuratorStartPrice = fullConfig.msrp.baseMsrp;
  toolsInfo.configModelPackageVersion = _.get(
    fullConfig,
    'config.OPTIONS.PACKAGES.more',
    []
  )
    .filter(x => x.selected === true)
    .map(x => x.id)
    .join();

  window.digitalData.forms.zeroLight = getZeroLight(params, fullConfig);
};

export const setNetPrice = netPrice => {
  window.digitalData.toolsInfo.configuratorEndPrice = netPrice;
};
